export default __webpack_public_path__ + "static/logo-romax-compact-tt-2bb9f86d411dbdd51a823385b866bde0.svg";